/** @deprecated 请使用 `useWhenCurReady`（`@/hooks/useWhenReady`） */
export { useWhenCurReady as default } from './useWhenReady';
